/**
 * Shared regex pattern for email tokens (base64url encoded, 43 characters)
 * Used across signup, join, and reset flows
 */
export const EMAIL_TOKEN_REGEX = /^[A-Za-z0-9_-]{43}$/;
